<template>
    <div class="pcoded-content">
        <title>{{ $t("klient.text_1") }} - DOFFERO®</title>
        <div class="under_bar_name">
            <under-bar-name :title="$t('klient.text_2')" :margin="false"></under-bar-name>
        </div>
        <div  class="klient_search_create">
            <div  class="filter1">
                <div class="page-header-title d-flex align-items-center position-relative">
                    <input v-model="search" class="filter_input" type="text" :placeholder="$t('klient.text_4')" :disabled="!is_paid"/>
                    <svg v-if="!loading" class="filter_svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <mask id="path-1-inside-1" fill="white">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M11.4947 4.42476C13.4129 6.41116 13.3577 9.5765 11.3713 11.4947C9.38488 13.413 6.21953 13.3577 4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476ZM13.5589 12.0175C15.5266 9.32026 15.3321 5.51944 12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607C5.31231 15.2974 9.21474 15.5845 11.992 13.5771L12.9187 14.5367L13.4306 15.0667L14.8199 16.5054L14.9713 16.3592L16.2586 15.1161L16.41 14.9699L15.0207 13.5312L14.5088 13.0011L13.5589 12.0175Z" />
                        </mask>
                        <path
                            d="M13.5589 12.0175L11.9432 10.8388L10.9522 12.1972L12.1203 13.4068L13.5589 12.0175ZM11.992 13.5771L13.4307 12.1878L12.226 10.9402L10.8204 11.9562L11.992 13.5771ZM12.9187 14.5367L14.3574 13.1474L12.9187 14.5367ZM13.4306 15.0667L11.9919 16.4561L13.4306 15.0667ZM14.8199 16.5054L13.3812 17.8947L14.7705 19.3334L16.2092 17.9441L14.8199 16.5054ZM14.9713 16.3592L13.582 14.9205L14.9713 16.3592ZM16.2586 15.1161L17.6479 16.5548L16.2586 15.1161ZM16.41 14.9699L17.7993 16.4085L19.238 15.0192L17.8487 13.5805L16.41 14.9699ZM15.0207 13.5312L13.582 14.9205L15.0207 13.5312ZM14.5088 13.0011L15.9475 11.6118L14.5088 13.0011ZM12.7606 12.9334C15.5416 10.2479 15.6189 5.8164 12.9334 3.03544L10.056 5.81408C11.207 7.00592 11.1738 8.90512 9.98196 10.0561L12.7606 12.9334ZM2.86261 12.7607C5.54815 15.5416 9.97963 15.619 12.7606 12.9334L9.98196 10.0561C8.79012 11.207 6.89092 11.1739 5.73997 9.98203L2.86261 12.7607ZM3.03538 2.86267C0.254416 5.54822 0.177064 9.9797 2.86261 12.7607L5.73997 9.98203C4.58902 8.79018 4.62217 6.89098 5.81401 5.74003L3.03538 2.86267ZM12.9334 3.03544C10.2478 0.254479 5.81634 0.177127 3.03538 2.86267L5.81401 5.74003C7.00585 4.58908 8.90506 4.62223 10.056 5.81408L12.9334 3.03544ZM15.1747 13.1962C17.7054 9.72716 17.4576 4.84131 14.372 1.64612L11.4947 4.42476C13.2067 6.19756 13.3478 8.91336 11.9432 10.8388L15.1747 13.1962ZM14.372 1.64612C10.9192 -1.9294 5.22159 -2.02885 1.64606 1.42399L4.4247 4.30135C6.4111 2.38311 9.57644 2.43836 11.4947 4.42476L14.372 1.64612ZM1.64606 1.42399C-1.92946 4.87684 -2.02891 10.5745 1.42393 14.15L4.30129 11.3713C2.38304 9.38494 2.43829 6.2196 4.4247 4.30135L1.64606 1.42399ZM1.42393 14.15C4.57473 17.4127 9.59131 17.7801 13.1636 15.198L10.8204 11.9562C8.83818 13.389 6.04988 13.1821 4.30129 11.3713L1.42393 14.15ZM10.5533 14.9664L11.48 15.926L14.3574 13.1474L13.4307 12.1878L10.5533 14.9664ZM11.48 15.926L11.9919 16.4561L14.8693 13.6774L14.3574 13.1474L11.48 15.926ZM11.9919 16.4561L13.3812 17.8947L16.2586 15.1161L14.8693 13.6774L11.9919 16.4561ZM16.2092 17.9441L16.3606 17.7979L13.582 14.9205L13.4306 15.0667L16.2092 17.9441ZM16.3606 17.7979L17.6479 16.5548L14.8693 13.6774L13.582 14.9205L16.3606 17.7979ZM17.6479 16.5548L17.7993 16.4085L15.0207 13.5312L14.8693 13.6774L17.6479 16.5548ZM17.8487 13.5805L16.4594 12.1419L13.582 14.9205L14.9713 16.3592L17.8487 13.5805ZM16.4594 12.1419L15.9475 11.6118L13.0702 14.3905L13.582 14.9205L16.4594 12.1419ZM15.9475 11.6118L14.9976 10.6282L12.1203 13.4068L13.0702 14.3905L15.9475 11.6118Z"
                            fill="#DDE3E8" mask="url(#path-1-inside-1)" />
                    </svg>
                    <svg v-else class="filter_svg rotating" width="17" height="17" viewBox="0 0 17 17"
                        xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="circleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color: #dde3e8; stop-opacity: 1" />
                                <stop offset="100%" style="stop-color: #adb3b7; stop-opacity: 1" />
                            </linearGradient>
                        </defs>
                        <circle cx="8.5" cy="8.5" r="8" fill="url(#circleGradient)" />
                        <circle cx="8.5" cy="8.5" r="6" fill="white" />
                    </svg>
                </div>
            </div>
            <div @click="addClientModal" class="create_klient mt-0">
                <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                {{ $t("klient.text_3") }}
            </div>
        </div>
        <klient-create 
            :editKlient="editKlient" :openModal="modalStatus" :klients="klients"
            :props_zdroj_kontaktu="props_zdroj_kontaktu" @closeModal="modalStatus = $event"
            @addClient="addClient($event)" />

        <max-offer-modal
            v-if="max_klient_limit_reached && showMaxKlientModal"
            :is_client="true"
            @closeModal="showMaxKlientModal = false"
        />
        <div v-if="filteredItems.length > 0" class="klients_table">
            <div class="klient_box_titles">
                <span> {{ $t("klient.text_5") }}</span>
                <span>{{ breakWordInMiddle($t("klient.text_6"))[0] }} <br />
                    {{ breakWordInMiddle($t("klient.text_6"))[1] }}</span>
                <span> {{ $t("klient.text_8") }}</span>
                <span>{{ breakWordInMiddle($t("klient.text_9"))[0] }} <br />
                    {{ breakWordInMiddle($t("klient.text_9"))[1] }}</span>
                <span>{{ breakWordInMiddle($t("klient.text_10"))[0] }} <br />
                    {{ breakWordInMiddle($t("klient.text_10"))[1] }}</span>
                <span> {{ $t("klient.text_48") }}</span>
                <span> {{ $t("klient.text_14") }}</span>
            </div>
            <div v-for="(klient, index) in filteredItems" :key="index">
                <div class="klient_box" :class="{'disabled': canShow(index)}" @click="(editKlient = klient), (modalStatus = true)">
                    <span>{{ klient.nazov }}</span>
                    <span> {{ klient.osoba }}</span>
                    <span class="my_tooltip">
                        {{ setEmail(klient.email) }}
                        <span v-if="klient.email && klient.email.length > 18" class="my_tooltiptext">
                            {{ klient.email }}</span>
                    </span>
                    <span>{{ klient.cislo }}</span>
                    <span>{{ klient.posledny_kontakt }}</span>
                    <span>{{ klient.spolocnost }}</span>
                    <div v-if="!canShow(index)" class="actions">
                        <button @click="((editKlient = klient), (modalStatus = true))" :title="$t('klient.text_15')"
                            class="my_tooltip edit">
                            <span class="my_tooltiptext">{{
                                $t("klient.text_15")
                                }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                fill="none">
                                <path d="M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5"
                                    stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M8.02 1.50999L4.08 5.44999C3.93 5.59999 3.78 5.89499 3.75 6.10999L3.535 7.61499C3.455 8.15999 3.84 8.53999 4.385 8.46499L5.89 8.24999C6.1 8.21999 6.395 8.06999 6.55 7.91999L10.49 3.97999C11.17 3.29999 11.49 2.50999 10.49 1.50999C9.49 0.509989 8.7 0.829989 8.02 1.50999Z"
                                    stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M7.45499 2.07498C7.78999 3.26998 8.72499 4.20498 9.92499 4.54498"
                                    stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button @click.stop="deleteKlient(klient.id)" :title="$t('klient.text_16')"
                            class="my_tooltip remove">
                            <span class="my_tooltiptext">{{
                                $t("klient.text_16")
                                }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                fill="none">
                                <path
                                    d="M10.5 2.99001C8.835 2.82501 7.16 2.74001 5.49 2.74001C4.5 2.74001 3.51 2.79001 2.52 2.89001L1.5 2.99001"
                                    stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M4.25 2.485L4.36 1.83C4.44 1.355 4.5 1 5.345 1H6.655C7.5 1 7.565 1.375 7.64 1.835L7.75 2.485"
                                    stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M9.42504 4.56999L9.10004 9.60499C9.04504 10.39 9.00004 11 7.60504 11H4.39504C3.00004 11 2.95504 10.39 2.90004 9.60499L2.57504 4.56999"
                                    stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.16496 8.25H6.82996" stroke="#F93C34" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M4.75 6.25H7.25" stroke="#F93C34" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <klients-alert-tomany v-if="!is_paid && filteredItems.length > 3" />
        </div>
        <div v-else>
            <h3 class="clients_notexists">{{ $t("klient.text_49") }}</h3>
        </div>
    </div>
</template>

<script>
import UnderBarName from "../../layouts/Header/UnderBarName.vue";
import KlientCreate from "./components/KlientCreate.vue";
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import KlientsAlertTomany from "./components/KlientsAlertTomany.vue";
export default {
    props: ["props_klients", "props_zdroj_kontaktu", "props_max_klient_limit_reached", "is_paid"],
    components: { UnderBarName, KlientCreate, KlientsAlertTomany },
    data() {
        return {
            modalStatus: false,
            klients: [],
            editKlient: null,
            search: null,
            debouncedSearch: null,
            loading: false, 
            showMaxKlientModal: false,
            max_klient_limit_reached: false,
        };
    },
    created() {
        this.klients = this.props_klients;
        this.max_klient_limit_reached = this.props_max_klient_limit_reached;
    },
    methods: {
        addClientModal() {
            if (this.max_klient_limit_reached) {
                this.showMaxKlientModal = true;
            }else{
                this.modalStatus = true;
                this.editKlient = null;
            }
        },
        addClient(klient) {
            this.klients.push(klient);
            this.max_klient_limit_reached = this.klients.length >= 3;
        },
        deleteKlient(id) {
            swal.fire({
                    title: this.$t("klient.text_17"),
                    text: this.$t("klient.text_18"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    cancelButtonText: this.$t("klient.text_19"),
                    confirmButtonText: this.$t("klient.text_20"),
                })
                .then((result) => {
                    if (result.value) {
                        axios.delete("/api/klients/" + id).then((response) => {
                            this.klients = this.klients.filter(
                                (client) => client.id !== id
                            );
                            this.$toast.success(this.$t("klient.text_21"), {
                                timeout: 2038,
                            });
                            this.max_klient_limit_reached = this.klients.length >= 3;
                        });
                    }
                });
        },
        breakWordInMiddle(word) {
            if (word == null) {
                return ["", ""];
            }
            let words = word.split(" ");
            if (words.length === 1) {
                return [words[0], ""];
            } else {
                return words;
            }
        },
        setEmail(email) {
            var len = email == null ? 0 : email.length;
            if (len < 18) return email;
            return email.slice(0, 17) + "...";
        },
        normalizeString(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
        canShow(index) {
            return index > 2 && !this.is_paid;
        }
    },
    watch: {
        search: {
            handler: function (newVal) {
                if (!this.is_paid) return;
                this.loading = true; // Start loading when a new search query is typed
                clearTimeout(this._debounceTimeout);
                this._debounceTimeout = setTimeout(() => {
                    this.debouncedSearch = newVal;
                    this.loading = false; // End loading once the debounced search is updated
                }, 300);
            },
            immediate: true,
        },
    },
    computed: {
        filteredItems() {
            if (!this.debouncedSearch || !this.is_paid) {
                return this.klients;
            }
            const normalizedSearch = this.normalizeString(
                this.debouncedSearch.toLowerCase()
            );
            return this.klients.filter((klient) => {
                const osobaMatch =
                    klient.osoba &&
                    this.normalizeString(klient.osoba.toLowerCase()).includes(
                        normalizedSearch
                    );
                const nazovMatch =
                    klient.nazov &&
                    this.normalizeString(klient.nazov.toLowerCase()).includes(
                        normalizedSearch
                    );
                const spolocnostMatch =
                    klient.spolocnost &&
                    this.normalizeString(
                        klient.spolocnost.toLowerCase()
                    ).includes(normalizedSearch);
                return osobaMatch || nazovMatch || spolocnostMatch;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
h3.clients_notexists {
    width: 863px;

    @media screen and (max-width: 1150px) {
        width: 97%;
    }

    text-align: center;
    margin: 0 auto;
    color: #9598a7;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-top: 20px;
}

.klients_table {
    position: relative;
    padding-bottom: 50px;
    width: 863px;

    @media screen and (max-width: 1150px) {
        width: 97%;
    }

    margin: 0 auto;

    .klient_box_titles {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding-left: 19px;

        span {
            color: var(--gray-400, #9ca3af);
            font-family: Montserrat;
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

            &:nth-of-type(1),
            &:nth-of-type(2) {
                width: 102px;
            }

            &:nth-of-type(3) {
                width: 160px;
            }

            &:nth-of-type(4) {
                width: 130px;
            }

            &:nth-of-type(5),
            &:nth-of-type(6) {
                width: 140px;
            }

            &:nth-of-type(7) {
                width: 60px;
            }
        }
    }

    .klient_box {
        display: flex;
        padding: 12px 0 12px 19px;
        align-items: center;
        border-radius: 6px;
        background: var(--White, #fff);
        margin-bottom: 5px;
        &.disabled {
            filter: blur(5px);
            pointer-events: none;
        }

        @media screen and (max-width: 1150px) {
            padding-right: 5px;
        }

        &:hover {
            background: #fafafa;
            cursor: pointer;
        }

        .actions {
            display: flex;

            .edit {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 24px;
                background: var(--gray-100, #f3f4f6);
                margin-right: 5px;
            }

            .remove {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 24px;
                background: var(--red-50, #fef2f2);
            }
        }

        span {
            color: var(--Blue, #212541);
            font-family: Montserrat;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

            &:nth-of-type(1),
            &:nth-of-type(2) {
                padding-right: 15px;
                width: 102px;
            }

            &:nth-of-type(3) {
                width: 160px;
            }

            &:nth-of-type(4) {
                width: 130px;
            }

            &:nth-of-type(5),
            &:nth-of-type(6) {
                width: 140px;
            }

            &:nth-of-type(7) {
                width: 60px;
            }
        }
    }
}

.klient_search_create {
    width: 863px;

    @media screen and (max-width: 1150px) {
        width: 97%;
    }

    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px auto 18px auto;
}

.under_bar_name {
    width: 863px;

    @media screen and (max-width: 1150px) {
        width: 97%;
    }

    margin: 0 auto;
    padding-top: 30px;
}

.filter1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0;
    order: unset !important;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    @media only screen and (max-width: 600px) {
        display: grid;
    }

    .filter_svg {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }

    .filter_svg2 {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 15px;
        cursor: pointer;
    }

    .filter_input {
        width: 300px;
        height: 55px;
        background: #ffffff;
        border: 1px solid #dde3e8;
        box-sizing: border-box;

        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;

        color: #9598a7;

        padding: 15px;
    }

    .d-inline h5 {
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #212541;
    }

    input {
        font-family: Roboto;
        font-style: normal;
        font-weight: 700;
        font-size: 11px;
        line-height: 16px;
        color: #212541;

        &::placeholder {
            color: #9598a7;
            text-transform: uppercase;
        }
    }
}

.create_klient {
    width: 230px;
    height: 55px;

    @media only screen and (max-width: 600px) {
        margin-top: 25px;
        width: 280px;
        float: left;
    }

    background: #2ed8b6;
    border-radius: 8px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: 0.5s all;
    float: right;

    &:hover {
        background: #23caa9;
        color: #ffffff;
    }

    &.disabled {
        cursor: no-drop;
        pointer-events: none;
        opacity: 0.3;
    }
}

.my_tooltip span.my_tooltiptext {
    width: auto !important;
    min-width: 115px !important;
    color: #fff !important;
}
</style>
